exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".isHidden{text-decoration:line-through}.isHidden:hover{text-decoration:line-through!important}", "", {"version":3,"sources":["C:/projects/Infrastil/evm/evm-frontend-react/src/components/Week/Event/Event.scss"],"names":[],"mappings":"AAAA,UACE,4BAA8B,CAAE,AAChC,gBACE,sCAAyC,CAAE","file":"Event.scss","sourcesContent":[".isHidden {\n  text-decoration: line-through; }\n  .isHidden:hover {\n    text-decoration: line-through !important; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":false,"sourceMap":true,"minimize":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/components/Week/Event/Event.scss
// module id = 726
// module chunks = 0